// extracted by mini-css-extract-plugin
module.exports = {"stickySection":"MobileFilters_stickySection__Xl1_C","filterRoot":"MobileFilters_filterRoot___y6_Q"};